// extracted by mini-css-extract-plugin
export var dateTimeButton = "_ir-1";
export var dateTimeButtonsContainer = "_ir-6";
export var dateTimeInputContainer = "_ir-7";
export var dateTimeWrapper = "_ir-8";
export var disabledTile = "_ir-0";
export var header = "_ir-2";
export var line = "_ir-3";
export var snoozeOption = "_ir-4";
export var time = "_ir-5";
export var todayTile = "_ir-9";
export var wrapper = "_ir-a";